module.exports = __webpack_public_path__ + "img/stage.3db6d6b6.png";